import { Box, Grid } from "@mui/material";

import { CardCore } from "src/Pages/components/CardCore/CardCore";
import { toAbsoluteUrl } from "src/shared/setup/toAbsoluteUrl";
import { TablesLandingPages } from "./components/TablesLandingPages";

export const LandingPages = () => {
  return (
    <>
      <Grid container spacing={4} mb={4}>
        <Grid item xs={12}>
          <CardCore
            sx={{ margin: "0 0 22px 0", height: "145px", overflow: "hidden" }}
          >
            <Box
              component="img"
              src={toAbsoluteUrl(
                "/media/Black Gold Minimalist Elegant Business LinkedIn Banner (1).svg"
              )}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center",
              }}
            />
          </CardCore>
        </Grid>
      </Grid>

      <TablesLandingPages />
    </>
  );
};
